<mat-card class="gtmt-card-container" [formGroup]="_CampagneTypologieService.SupportFormGroup">

    <mat-card-title>Grammage</mat-card-title>

    <mat-card-content>
        <mat-grid-list cols="1" rowHeight="3.5rem" [gutterSize]="'1rem'">
            <mat-radio-group formControlName="CodeGrammageSupport" aria-labelledby="dimension-radio-group-label"
                class="dimension-radio-group">
                <mat-grid-tile class="gtmt-checkbox-container" colspan="1" rowspan="0.5"
                    (click)="_CampagneTypologieService.SupportFormGroup.get('CodeGrammageSupport').setValue(dataGrammagesSupport.CodeGrammageSupport)"
                    *ngFor="let dataGrammagesSupport of _CampagneTypologieService.dataGrammagesSupports">
                    <span> {{dataGrammagesSupport.GrammageSupport}}</span>
                    <mat-radio-button [value]="dataGrammagesSupport.CodeGrammageSupport">
                    </mat-radio-button>
                </mat-grid-tile>
            </mat-radio-group>
        </mat-grid-list>
    </mat-card-content>

    <mat-card-actions>
        <button mat-raised-button color="blue" (click)="Valider()">
            Valider la sélection
        </button>
    </mat-card-actions>

</mat-card>